import { render, staticRenderFns } from "./fertigerCapacityComponent.vue?vue&type=template&id=520ae996&scoped=true"
import script from "./fertigerCapacityComponent.vue?vue&type=script&lang=js"
export * from "./fertigerCapacityComponent.vue?vue&type=script&lang=js"
import style0 from "./fertigerCapacityComponent.vue?vue&type=style&index=0&id=520ae996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ae996",
  null
  
)

export default component.exports